import {useEffect, useState} from 'react';

export function useTabLock(namespace: string, id: string | null): {isTaken: boolean | null} {
    const [isTaken, setIsTaken] = useState<boolean | null>(null);

    useEffect(() => {
        if (!id) {
            setIsTaken(false);
            return () => {
                // noop
            };
        }

        if (typeof navigator?.locks === 'undefined') {
            setIsTaken(false);
            return () => {
                // noop
            };
        }

        const lockName = `ncc-${namespace}-lock-${id}`;
        const abortController = new AbortController();
        let released = false;

        const holdLock = (): Promise<void> =>
            new Promise<void>((resolve) => {
                if (abortController.signal.aborted) {
                    resolve();
                    return;
                }
                abortController.signal.addEventListener('abort', () => resolve());
            });

        navigator.locks.request(lockName, {ifAvailable: true}, async (lock) => {
            if (lock !== null) {
                setIsTaken(false);
                await holdLock();
                released = true;
                return;
            }

            setIsTaken(true);

            await navigator.locks
                .request(lockName, {signal: abortController.signal}, async () => {
                    if (released) return;
                    setIsTaken(false);
                    await holdLock();
                })
                .catch(() => {
                    // noop
                });
        });

        return () => {
            abortController.abort();
        };
    }, [namespace, id]);

    return {isTaken};
}
